// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.menu-badge span {\n  font-size: small;\n  font-weight: bold;\n  height: 18px;\n  width: 18px;\n  padding-top: 2px;\n}\n", ""]);
// Exports
module.exports = exports;
